import produce from 'immer';
import {
  ReadSearchApiArg,
  SearchFilterConditionDate,
  SearchScope,
} from 'lib-search-types';
import moment from 'moment-timezone';
import { Writable } from 'ts-essentials';

import { isDateFilterField } from 'app/views/layout/views/search/utils/date/isDateFilterField';
import { isLeafFilterCondition } from 'app/views/layout/views/search/utils/filters/filterTypeGuards';

export function transformReadSearchArg<
  TScope extends SearchScope,
  TEnriched extends boolean = false,
>(arg: ReadSearchApiArg<TScope, TEnriched>): typeof arg {
  return produce(arg, (draftArg) => {
    // Quoted queries (e.g. "John Doe") enable strict/exact matching
    if (draftArg.query) {
      const normalized = draftArg.query.replace(
        /[\u201C\u201D\u201E\uFF02]/g,
        '"',
      );

      if (
        normalized.length > 2 &&
        normalized.startsWith('"') &&
        normalized.endsWith('"')
      ) {
        const inner = normalized.slice(1, -1);

        if (!inner.includes('"')) {
          draftArg.query = inner;
          draftArg.isStrict = true;
        }
      }
    }

    if (draftArg.filters) {
      draftArg.filters.filters.forEach((condition) => {
        if (
          isLeafFilterCondition(condition) &&
          isDateFilterField(condition.field)
        ) {
          (condition as Writable<SearchFilterConditionDate>).meta = {
            timezone: moment.tz.guess(),
          };
        }
      });
    }
  });
}
